import { useEffect, useState } from "react";
import "./PaymentReturn.css";

export function PaymentReturn({ orderId }) {
  const [result, setResult] = useState({ state: "checking" });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!/^[a-f0-9]{32}$/.test(orderId || "")) {
      setResult({ state: "unknown" });
      return;
    }
    let stopped = false;
    let timer;
    let checks = 0;
    const controller = new AbortController();
    setResult({ state: "checking" });
    const check = async () => {
      checks += 1;
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch("/api/payments/tbank/result", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ paymentId: orderId }), signal: controller.signal,
        });
        if (!response.ok) throw new Error("receipt_unavailable");
        const data = await response.json();
        if (stopped) return;
        if (data.paid === true) {
          setResult({ state: "paid", coins: Number(data.credited_coins) });
          return;
        }
        if (data.failed === true) {
          setResult({ state: "failed" });
          return;
        }
      } catch {
        if (stopped) return;
        setResult({ state: "unknown" });
        return;
      } finally {
        window.clearTimeout(timeout);
      }
      if (checks >= 30) setResult({ state: "waiting" });
      else timer = window.setTimeout(check, 3000);
    };
    check();
    return () => { stopped = true; controller.abort(); window.clearTimeout(timer); };
  }, [orderId, attempt]);

  const paid = result.state === "paid";
  const failed = result.state === "failed";
  const checking = result.state === "checking";
  const title = paid ? "Баланс пополнен!" : failed ? "Оплата не завершена" : checking ? "Проверяем оплату…" : "Ожидаем подтверждение";
  const description = paid
    ? "Вы успешно пополнили баланс MetaCard. Монеты уже на вашем аккаунте — пора возвращаться к приключениям!"
    : failed ? "Банк не подтвердил оплату. Вернитесь в Telegram, чтобы попробовать ещё раз."
    : "Проверяем зачисление на ваш аккаунт. Можно вернуться в Telegram — баланс обновится после подтверждения платежа.";

  return <main className={`mc-payment-return ${paid ? "is-paid" : ""}`}>
    <div className="mc-payment-return-stars" aria-hidden="true">{Array.from({ length: 12 }, (_, i) => <i key={i} style={{ "--i": i }} />)}</div>
    <section className="mc-payment-return-card" aria-labelledby="payment-return-title">
      <div className="mc-payment-return-brand">✦ METACARD</div>
      <div className="mc-payment-return-emblem" aria-hidden="true">
        <span className="mc-payment-return-orbit" />
        <img src="/assets/resource-emojis/coin.webp" alt="" />
        <span className={`mc-payment-return-badge ${checking ? "is-checking" : ""}`}>{paid ? "✓" : failed ? "×" : "✦"}</span>
      </div>
      <div role="status" aria-live="polite" aria-atomic="true">
        <p className="mc-payment-return-eyebrow">{paid ? "ОПЛАТА ПРОШЛА УСПЕШНО" : "ПОПОЛНЕНИЕ БАЛАНСА"}</p>
        <h1 id="payment-return-title">{title}</h1>
        <p className="mc-payment-return-description">{description}</p>
        {paid && Number.isFinite(result.coins) && <div className="mc-payment-return-amount"><span>+{result.coins.toLocaleString("ru-RU")}</span><small>MetaCoin зачислено</small></div>}
      </div>
      <a className="mc-payment-return-telegram" href="https://t.me/Meta_CardBot">
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21.4 3.6 18 20c-.3 1.2-1 1.5-2 .9l-5.2-3.9-2.5 2.4c-.3.3-.5.5-1 .5l.4-5.3L17.4 6c.4-.4-.1-.6-.6-.3L4.8 13.3-.4 11.7c-1.1-.4-1.1-1.1.2-1.6L20.1 2.5c.9-.3 1.7.2 1.3 1.1Z" /></svg>
        Вернуться в Telegram <span aria-hidden="true">↗</span>
      </a>
      {!paid && !checking && <button className="mc-payment-return-retry" onClick={() => setAttempt(value => value + 1)}>Проверить ещё раз</button>}
      <p className="mc-payment-return-footer">Ваши карты и новые истории ждут вас в боте</p>
    </section>
  </main>;
}
